const EmployeeFilterSummary = ({

    selectedBranches,
    selectedDepartments,
    selectedRoles,
    selectedAccess,
    loginFrom,
    loginTo,

    setSelectedAccess,
    setLoginFrom,
    setLoginTo,

    setSelectedBranches,
    setSelectedDepartments,
    setSelectedRoles,

    clearAllFilters

}) => {

    const hasFilters =

        selectedBranches.length > 0 ||
        selectedDepartments.length > 0 ||
        selectedRoles.length > 0 ||
        selectedAccess !== "" ||
        loginFrom ||
        loginTo;

    if (!hasFilters) return null;

    return (

        <div className="filter-summary-row">

            <div className="active-filters-summary">

                <span className="filters-label">
                    Active Filters:
                </span>

                {/* Branch Filters */}
                {selectedBranches.map((branch, index) => (

                    <span
                        key={index}
                        className="filter-badge branch"
                    >

                        Branch: {branch}

                        <button
                            className="clear-filter-btn"
                            onClick={() =>
                                setSelectedBranches(
                                    selectedBranches.filter(
                                        b => b !== branch
                                    )
                                )
                            }
                        >
                            ×
                        </button>

                    </span>

                ))}

                {/* Department Filters */}
                {selectedDepartments.map((department, index) => (

                    <span
                        key={index}
                        className="filter-badge department"
                    >

                        Dept: {department}

                        <button
                            className="clear-filter-btn"
                            onClick={() =>
                                setSelectedDepartments(
                                    selectedDepartments.filter(
                                        d => d !== department
                                    )
                                )
                            }
                        >
                            ×
                        </button>

                    </span>

                ))}

                {/* Role Filters */}
                {selectedRoles.map((role, index) => (

                    <span
                        key={index}
                        className="filter-badge role"
                    >

                        Role: {role}

                        <button
                            className="clear-filter-btn"
                            onClick={() =>
                                setSelectedRoles(
                                    selectedRoles.filter(
                                        r => r !== role
                                    )
                                )
                            }
                        >
                            ×
                        </button>

                    </span>

                ))}
                {/* ACCESS FILTER */}

                {selectedAccess && (

                    <span className="filter-badge access">

                        Access:
                        {selectedAccess === "true"
                            ? " Active"
                            : " Inactive"}

                        <button
                            className="clear-filter-btn"
                            onClick={() =>
                                setSelectedAccess("")
                            }
                        >
                            ×
                        </button>

                    </span>

                )}

                {/* LOGIN FROM */}

                {loginFrom && (

                    <span className="filter-badge login">

                        From: {loginFrom}

                        <button
                            className="clear-filter-btn"
                            onClick={() =>
                                setLoginFrom("")
                            }
                        >
                            ×
                        </button>

                    </span>

                )}

                {/* LOGIN TO */}

                {loginTo && (

                    <span className="filter-badge login">

                        To: {loginTo}

                        <button
                            className="clear-filter-btn"
                            onClick={() =>
                                setLoginTo("")
                            }
                        >
                            ×
                        </button>

                    </span>

                )}

                <button
                    className="clear-all-btn"
                    onClick={clearAllFilters}
                >
                    Clear All
                </button>

            </div>

        </div>

    );
};

export default EmployeeFilterSummary;